import { Trash } from "@phosphor-icons/react";
import cx from "classnames";

interface ListItemDeleteButtonProps {
  ariaLabel: string;
  "data-testid": string;
  onClick: () => void;
}

/**
 * Owner-only delete control for Ask Puntt chats/projects list cards (and list
 * rows). Sits top-right of a `group`-hoverable card: resting is a plain black
 * trash glyph; hovering the control itself fills a red circle with a white
 * trash (circle, not the square sidebar IconButton). Opacity is gated on the
 * parent group hover so the chrome stays quiet until the row/card is focused.
 */
export function ListItemDeleteButton({
  ariaLabel,
  "data-testid": testId,
  onClick,
}: ListItemDeleteButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      data-testid={testId}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={cx(
        "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full",
        "text-puntt-neutral-gray-12 opacity-0 transition-colors",
        "hover:bg-puntt-red-9 hover:text-base-white",
        "focus-visible:opacity-100 group-hover:opacity-100",
      )}
    >
      <Trash size={14} aria-hidden="true" />
    </button>
  );
}
